// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__P9F-G","col":"CardReaderDesc_col__19UPC","label":"CardReaderDesc_label__1E7yT"};